import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import {
    LocationOnOutlined,
    BusinessCenterOutlined,
    VerifiedUserOutlined,
    AttachMoneyOutlined,
    PermIdentity,
    LocalAtmOutlined,
    EditOutlined,
    AccountBalanceOutlined,
    TurnedInOutlined,
    CheckCircleOutlined
} from '@material-ui/icons';
import IconButton from "@material-ui/core/IconButton";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { ICliente } from '../../entities/catalogos/ICliente';
import { enums } from "../../enums/enums";
import ConfirmDialog from '../controls/ConfirmDialog';
import {Mercancia} from "../../entities/solicitudes/Mercancia";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



export interface IStep {
    id: any
    nombre: string
    esUltimoPaso?: boolean
    tipo?: string
    disabled?: boolean
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    cliente: ICliente
    mercancias: Mercancia[]
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = IStep & StateProps & DispatchProps

const StepSolicitud = ({ id, nombre, solicitud, solicitudCopia, setSolicitud, setSolicitudCopia, esUltimoPaso = false, cliente, mercancias, disabled = false }: Props) => {

    const [showConfirmDialog, setConfirmDialog] = useState(false);
    let requerido = false;
    let activo = id === solicitud.seccionId;

    if (id === solicitud.seccionId) {
        activo = true;
    }
    else if (cliente.grupoClienteID === 0 && cliente.habilitarClienteLogistico && !cliente.clienteCreditoProyecto?.length && id === 1.1 && solicitud.seccionId === 1) {
        activo = true;
    }
    else if (cliente.grupoClienteID === 1 && cliente.habilitarClienteLogistico && id === 1 && solicitud.seccionId === 1) {
        activo = true;
    }
    else if (cliente.grupoClienteID === 0 && !cliente.clienteCreditoProyecto?.length && id === 2 && solicitud.seccionId === 1) {
        activo = true;
    }
    else if((!cliente.clienteCreditoProyecto || (cliente.clienteCreditoProyecto.length == 1 && cliente.clienteCreditoProyecto[0].clienteCreditoProyectoID == 0)) && id === 1.1  && solicitud.seccionId == 1 && cliente.habilitarClienteLogistico)
    {
        activo = true;
    }
    else if((!cliente.clienteCreditoProyecto || (cliente.clienteCreditoProyecto.length == 1 && cliente.clienteCreditoProyecto[0].clienteCreditoProyectoID == 0)) && id === 2  && solicitud.seccionId == 1 && !cliente.habilitarClienteLogistico)
    {
        activo = true;
    }
    let estiloRequerido ="oval";
    if(solicitud.completada===false && (solicitud?.cotizacionId??0) >0)
    {
        if(enums.estatusSolicitud.origenDestino === id)
        {
            if (!solicitud.distribuidorRemitente) {
                requerido=true;
            }
            if (!solicitud.contactoOrigen) {
                requerido=true;
            }
            if (!solicitud.distribuidorDestinatario) {
                requerido=true;
            }
            if (!solicitud.contactoDestino) {
                requerido=true;
            }
            if (!solicitud.fechaRecoleccion && !solicitud.fechaCitaRad && solicitud.tipoRecoleccionIdOrigen !== 3) {
                requerido=true;
            }
        }
        else if (enums.estatusSolicitud.datosMercancia === id)
        {
            if ((mercancias?.length??0)==0) {
                requerido=true;
            }
            if (!solicitud.descripcionMercancia) {
                requerido=true;
            }
            if ((cliente?.clienteReferencias?.length??0) > 0 && solicitud.clienteReferencias?.length === 0) {
                requerido=true;
            }
        }
        if(requerido)
        {
            estiloRequerido += " " + "blink"
            activo=true;
        }
    }

    let completado = solicitud.estatusId >= id;
    const estilos = activo ? "active" : completado ? "completed" : solicitud.seccionId == 8 && !solicitud.modificar ? "completed" : "pending";

    let icono = {
        [enums.estatusSolicitud.inicial]: <LocalAtmOutlined />,
        [enums.estatusSolicitud.facturador]: <AccountBalanceOutlined />,
        [enums.estatusSolicitud.proyecto]: <TurnedInOutlined />,
        [enums.estatusSolicitud.origenDestino]: <LocationOnOutlined />,
        [enums.estatusSolicitud.datosMercancia]: <BusinessCenterOutlined />,
        [enums.estatusSolicitud.serviciosAdicionales]: <VerifiedUserOutlined />,
        [enums.estatusSolicitud.datosCliente]: <PermIdentity />,
        [enums.estatusSolicitud.markup]: <AttachMoneyOutlined />,
        [enums.estatusSolicitud.cotizacion]: <LocalAtmOutlined />
    };

    const cambiarSeccion = () => {
        if (disabled) {
            return;
        }
        setConfirmDialog(true);
    };

    const handleConfirmar = () => {
        if (disabled) {
            setConfirmDialog(false);
            return;
        }
        //El tipo de envío y la cotización comparten el mismo step (7), si ya se creo la solicitud (estatusId >= 8)
        //se va hacía el resumen de la solicitud, en caso contrario al tipo de envío, siempre y cuando se quiera ir a ese step.
        const seccionId = id === 6 && solicitud.estatusId >= enums.estatusSolicitud.resumen ? enums.estatusSolicitud.resumen: id;

        const nuevaCotizacion = new Solicitud({ ...solicitud, seccionId, tipoServicio: solicitudCopia.tipoServicio });
        if(solicitudCopia.cotizacionId==0 || solicitudCopia.cotizacionId==undefined)
        {
            nuevaCotizacion.esSeguroBasico=solicitudCopia.esSeguroBasico;
            nuevaCotizacion.esSeguroMercancia=solicitudCopia.esSeguroMercancia;
        }
        setSolicitud(nuevaCotizacion);
        //Copia todos los valores de la solicitud a su copia para reestablecer los valores en el Resumen
        setSolicitudCopia(nuevaCotizacion);
        setConfirmDialog(false);
    };

    const handleClose = () => {
        setConfirmDialog(false);
    };

    const mostrarEditar = (): boolean => {
        const mostrar = !!solicitud.modificar && !solicitud.enviada;
        const opcionActivo = activo && !solicitud.completada && requerido;
        const opcionInactivo = !activo && ((completado && !solicitud.completada) || !!solicitud.completada );
        return mostrar && (opcionActivo || opcionInactivo);
    };

    return (<>
        <Box display="flex" flexDirection="column" alignItems="center" className={estilos}>

            {!activo && completado &&
                <Box display="flex" justifyContent="center" alignItems="center" className="complete">
                    <CheckCircleOutlined />
                </Box>
            }
            <Box display="flex" justifyContent="center" alignItems="center" className={estiloRequerido}>
                {icono[id]}
            </Box>

            <Box className="step-label" style={{ position: "relative" }}>
                <span style={{
                    position: "absolute",
                    width: mostrarEditar() ? "140px" : "130px",
                    textAlign: "center",
                    left: "-60px"
                }}>
                    {nombre}
                    {mostrarEditar() &&
                        <IconButton disabled={disabled} size="small" onClick={cambiarSeccion}>
                            <EditOutlined style={{ fontSize: 15 }} />
                        </IconButton>
                    }
                </span>
            </Box>
        </Box>

        {!esUltimoPaso &&
            <Grid item xs={1} className="step-container" style={{ maxWidth: "6%" }}>
                <div className="circle" />
                <div className="circle" />
            </Grid>
        }

        {showConfirmDialog &&
        //¿Desea cambiar de sección sin guardar los cambios?
            <ConfirmDialog titulo={traducirLabel(333)} contenido={traducirMessage(23)} abierto={showConfirmDialog} confirmar={handleConfirmar} cerrar={handleClose}></ConfirmDialog>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    mercancias: state.mercancias
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepSolicitud);
